import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faCheck, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

const Item = ({ item, EditItem, CompleteItem, RemoveItem }) => {
    
    const [editView, toggleEdit] = useState(false)
    const [updatedItem, updateItem] = useState('')
    
    const handleSubmit = e => {
        e.preventDefault()
        if (updatedItem !== '') {
            EditItem(item, {"item": updatedItem, "completed": false})
            updateItem('')
            toggleEdit(false)
        }
    } 

    return (
        <div className="item">
            <div className="item__name">
                {editView ? (
                    <form onSubmit={handleSubmit}>
                        <input 
                            type="text" 
                            placeholder="Edit Item"
                            value={updatedItem}
                            onChange={e => updateItem(e.target.value)}
                        />
                        <button className="btn btn--submit">Update</button>
                    </form>
                ) : (
                    <div className={item.completed ? 'completed' : 'no'}>{item.item}</div>
                )}
            </div>
            <div className="item__buttons">
                <button onClick={() => toggleEdit(!editView)} className="btn btn--icons">
                    <FontAwesomeIcon icon={faEdit} alt="Edit"/>
                </button>
                <button onClick={() => CompleteItem(item)} disabled={item.completed} className="btn btn--icons">
                    <FontAwesomeIcon icon={faCheck} alt="Complete"/>
                </button>
                <button onClick={() => RemoveItem(item)} className="btn btn--icons">
                    <FontAwesomeIcon icon={faMinus} alt="Remove"/>
                </button>
            </div>
        </div>
    )
}

export default Item